// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3bRsi","label":"Category_label__2B4yU","content":"Category_content__2ubvb","header":"Category_header__2rXpQ","location":"Category_location__2lkVO"};